function getCompanyStatus(slot) {

  if (!Array.isArray(slot) || slot.length === 0) {
    return { status: "Closed", time: "" };
  }

  const now = new Date();

  // JS: 0 (Sun) – 6 (Sat)
  // API: 1 (Mon) – 7 (Sun)
  const jsDay = now.getDay();
  const today = jsDay === 0 ? 7 : jsDay;

  // 🔥 Pick ONLY today's slot
  const todaySlot = slot.find(item => item.day === today);
  console.log("times", todaySlot?.start_time, todaySlot?.end_time);
  if (!todaySlot?.start_time || !todaySlot?.end_time) return { status: "Closed", time: "" };


  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();
  const date = now.getUTCDate();

  const startUTC = new Date(Date.UTC(year, month, date, ...todaySlot.start_time.split(":")));
  const endUTC = new Date(Date.UTC(year, month, date, ...todaySlot.end_time.split(":")));

  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const startLocal = new Date(
    startUTC.toLocaleString("en-US", { timeZone: localTimeZone })
  );
  const endLocal = new Date(
    endUTC.toLocaleString("en-US", { timeZone: localTimeZone })
  );

  const startTimeFormatted = formatTime(startLocal);
  const endTimeFormatted = formatTime(endLocal);


  if (startTimeFormatted === "12:00 AM" && endTimeFormatted === "11:59 PM") {
    return { status: "Available 24/7", time: "" };
  }
  if (now >= startLocal && now <= endLocal || now >= startLocal && endLocal < startLocal) {
    return { status: "Open", time: `Closes ${formatTime(endLocal)}` };
  } else {
    return { status: "Closed", time: `Opens ${formatTime(startLocal)}` };
  }
}

function formatTime(date) {
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12;
  const formattedHours = hours.toString().padStart(2, '0');

  return `${formattedHours}:${minutes} ${ampm}`;
}

export { getCompanyStatus };